import { useEffect, useState } from 'react';
import { checkWindow, getClickToCallWithKeyOrUrl, trackView } from '@vfit/shared/data-access';
import { VfModal } from '@vfit/shared/components';
import {
  API,
  requireStaticImageAtomComponent,
  purifyTextWithLogo,
  AppMobile,
} from '@vfit/shared/data-access';
import { purify } from '@vfit/shared/themes';
import {
  CONSUMER_CMS_DEFAULT,
  getCurrentUserType,
  getSelectedOfferIds,
  handleFirstCharacterOfSentence,
  ICoverageToolCongifg,
  IUserType,
  LOCK_IN_IS_ACCEPTED_FROM_HUB,
  useCampaignAccept,
  useCmsConfig,
  useGetShoppingCartSilentUpdate,
} from '@vfit/consumer/data-access';
import { CoverageErrorType } from '@vfit/shared/models';
import { ICommonData } from '../../../StepperStateCards/stepperStateCards.models';
import { DEFAULT_ADDRESS, useCoverageToolModalProvider } from '../../coverageToolModal.context';
import { IModalConfig } from './coverageToolMapCard.models';
import { ButtonDiv, ModalDescription, ModalTitle, ModalWrap } from './coverageToolMapCard.style';
import { ButtonCBU, getAddress } from '@vfit/consumer/components';
import { EditAddress } from '../CoverageToolOtpCard/coverageToolOtpCard.style';
import CoverageToolMap from './components/CoverageToolMap/coverageToolMap';
import CoverageToolMapCardTagging from './coverageToolMapCard.tagging';
import { useCoverageToolMapCard } from './coverageToolMapCard.hook';
import { useQueryClient } from 'react-query';

const CoverageToolMapCard = ({
  handleGoNextSlide,
  handleGoPrevSlide,
  handleOnClose,
}: ICommonData) => {
  const [acceptOrderId, setAcceptOrderId] = useState<string>('');
  const [isOnFinish, setIsOnFinish] = useState<boolean>(false);
  const [isLoadingCampaigns, setIsLoadingCampaigns] = useState<boolean>(false);
  const [isStartLoggedLockin, setIsStartLoggedLockin] = useState<boolean>(false);
  const {
    isSuccess,
    address,
    product,
    isManual,
    isLoading,
    isError,
    errorCoverage,
    setSlidesGoBack,
    setAddress,
    setIsAddressConfirmed,
    setIsError,
    setIsLoading,
    setIsSuccess,
  } = useCoverageToolModalProvider();
  const {
    data: acceptData,
    isLoading: isLoadingAccept,
    isSuccess: isSuccessAccept,
    isError: isErrorAccept,
    mutate: mutateAccept,
  } = useCampaignAccept();
  const {
    isLoading: isLoadingShoppingCart,
    isSuccess: isSuccessShoppingCart,
    isError: isErrorShoppingCart,
    refetch: refetchShoppingCart,
  } = useGetShoppingCartSilentUpdate(acceptOrderId, {
    enabled: false,
    keyDependency: ['getShoppingCartLockIn'],
  });
  const { campaigns, checkEligibility } = useCoverageToolMapCard(isStartLoggedLockin);
  const client = useQueryClient();
  const { errorType } = errorCoverage;
  const INIT_MODAL_CONFIG: IModalConfig = {
    isOpen: false,
    title: '',
    description: '',
    firstActionLabel: '',
    firstAction: () => {
      return;
    },
    secondActionLabel: '',
    secondAction: () => {
      return;
    },
  };
  const [modalConfig, setModalConfig] = useState<IModalConfig>(INIT_MODAL_CONFIG);
  const isLoggedUser = getCurrentUserType() === IUserType.LOGGED_USER;
  const isFwaTech =
    checkWindow() &&
    localStorage.getItem('isTechFWA') !== 'undefined' &&
    localStorage.getItem('isTechFWA') === 'true';

  const coverageToolConfig = useCmsConfig(
    CONSUMER_CMS_DEFAULT,
    API.CMS_GET_COVERAGE_TOOL_CONFIG
  ) as ICoverageToolCongifg;

  const goNext = () => {
    setIsLoadingCampaigns(false);
    setIsOnFinish(true);
    handleGoNextSlide?.({}, true);
  };

  const onClickEditAddress = () => {
    setModalConfig({ ...INIT_MODAL_CONFIG });
    setTimeout(() => {
      setSlidesGoBack(isManual ? 2 : 1);
    }, 200);
  };

  const onClickCallMeNow = () => {
    const isFwaTech =
      checkWindow() &&
      localStorage.getItem('isTechFWA') !== 'undefined' &&
      localStorage.getItem('isTechFWA') === 'true';
    if (isFwaTech && product?.urlClickToCallNoCoverageFwa) {
      getClickToCallWithKeyOrUrl(client, product?.urlClickToCallNoCoverageFwa, product);
    } else if (product?.callMeNowHelp?.url)
      getClickToCallWithKeyOrUrl(client, product?.callMeNowHelp?.url, product);
  };

  const modalErrorNoCoverage = () => {
    const addressLocal = getAddress();
    const composedAddress = `${address?.street} ${address?.streetNumber} - ${address?.city}`;

    trackView({
      event_name: 'journey_end',
      event_label_track: 'no coverage',
      event_category: 'journey',
      page_type: 'ko',
      tracking_type: 'view',
      journey_name: 'verify lock-in',
      page_subsection: 'lock-in',
    });

    if (!isFwaTech) {
      const koCoverageLabel = {
        title: coverageToolConfig?.coveragetool?.koCoverageTool?.title || '',
        description:
          coverageToolConfig?.coveragetool?.koCoverageTool?.description?.replace(
            'PLACEHOLDER',
            `${composedAddress}` || ''
          ) || '',
        buttonList: [
          {
            text: coverageToolConfig?.coveragetool?.koCoverageTool?.buttonEditAddress || '',
          },
          {
            text: coverageToolConfig?.coveragetool?.koCoverageTool?.buttonCallsYou || '',
          },
        ],
      };

      setModalConfig({
        isOpen: true,
        onCloseAction: handleOnClose,
        title: koCoverageLabel?.title,
        ...(addressLocal?.displayedAddress && {
          subDesc: (
            <div>
              <h4>
                <b>Indirizzo</b>
              </h4>
              <p>{handleFirstCharacterOfSentence(addressLocal?.displayedAddress || '')}</p>
            </div>
          ),
        }),
        description: koCoverageLabel?.description,
        firstActionLabel: koCoverageLabel?.buttonList?.[0]?.text,
        firstAction: onClickEditAddress,
        secondActionLabel: koCoverageLabel?.buttonList?.[1]?.text,
        secondAction: onClickCallMeNow,
      });
    } else {
      const koCoverageLabel = {
        title: coverageToolConfig?.coveragetool?.koCoverageToolFwa?.title || '',
        description:
          coverageToolConfig?.coveragetool?.koCoverageToolFwa?.description.replace(
            'PLACEHOLDER',
            `${handleFirstCharacterOfSentence(addressLocal?.displayedAddress || '')}` || ''
          ) || '',
        buttonList: [
          {
            text: coverageToolConfig?.coveragetool?.koCoverageToolFwa?.buttonEditAddress || '',
          },
          {
            text: coverageToolConfig?.coveragetool?.koCoverageToolFwa?.buttonCallsYou || '',
          },
        ],
      };
      setModalConfig({
        isOpen: true,
        onCloseAction: handleOnClose,
        title: koCoverageLabel?.title,
        description: koCoverageLabel?.description,
        firstActionLabel: koCoverageLabel?.buttonList?.[0]?.text,
        firstAction: onClickEditAddress,
        secondActionLabel: koCoverageLabel?.buttonList?.[1]?.text,
        secondAction: onClickCallMeNow,
      });
    }
  };

  const goPrevSlide = () => {
    setAddress(DEFAULT_ADDRESS);
    setIsAddressConfirmed(false);
    setIsOnFinish(false);
    setIsError(false);
    setIsLoading(false);
    setIsSuccess(false);
    handleGoPrevSlide?.();
  };

  const checkLockin = () => {
    if (checkEligibility?.eligible && checkEligibility?.lockInProduct) {
      mutateAccept({
        campaignId: checkEligibility.lockInOffer?.id || '',
        sessionId: checkEligibility.lockInOffer?.sessionId || '',
      });
    } else {
      goNext();
    }
  };

  const confirmAddress = () => {
    setIsAddressConfirmed(true);
  };

  const handleOnCloseError = () => {
    switch (errorType) {
      case CoverageErrorType.R2_LOGGED:
        window.location.href = '/';
        break;
      default:
        goPrevSlide();
    }
  };

  const goNextSlide = () => {
    const isApp = AppMobile.checkIsApp();
    const isLockInProduct = product?.isLockInProduct;

    if (!isLockInProduct || isApp) {
      goNext();
      return;
    }

    const { offerId: filterOfferId } = getSelectedOfferIds();

    if (!filterOfferId) {
      modalErrorNoCoverage();
      return;
    }

    if (!isLoggedUser) {
      handleGoNextSlide?.();
      return;
    }

    setIsLoadingCampaigns(true);
    setIsStartLoggedLockin(true);
  };

  useEffect(() => {
    if (acceptOrderId) refetchShoppingCart();
  }, [acceptOrderId]);

  useEffect(() => {
    if (isErrorShoppingCart) {
      goNext();
    } else if (isSuccessShoppingCart) {
      localStorage.setItem(LOCK_IN_IS_ACCEPTED_FROM_HUB, '1');
      goNext();
    }
  }, [isSuccessShoppingCart, isErrorShoppingCart, isLoadingShoppingCart]);

  useEffect(() => {
    if (isErrorAccept) {
      goNext();
    } else if (isSuccessAccept) {
      setAcceptOrderId(acceptData?.orderId || '');
    }
  }, [isSuccessAccept, isErrorAccept, isLoadingAccept]);

  useEffect(() => {
    if (campaigns?.isSuccess && checkEligibility && !isOnFinish) {
      checkLockin();
    }
  }, [campaigns]);

  useEffect(() => {
    if (campaigns?.isError) {
      goNext();
    }
  }, [campaigns.isError]);

  useEffect(() => {
    if (isStartLoggedLockin) setIsStartLoggedLockin(false);
  }, [isStartLoggedLockin]);

  useEffect(() => {
    if (isSuccess) {
      goNextSlide();
    }
  }, [isSuccess]);

  const [pTitle, pDescription] = purify(
    [modalConfig.title, modalConfig.description],
    purifyTextWithLogo
  );

  return (
    <>
      <CoverageToolMapCardTagging />
      <CoverageToolMap
        onConfirm={confirmAddress}
        onEditAddress={goPrevSlide}
        address={address}
        isLoading={
          isLoading || (isError && !product?.isLockInProduct) || isOnFinish || isLoadingCampaigns
        }
        lottieFile={
          product?.loaders?.coverageTool &&
          requireStaticImageAtomComponent(product.loaders.coverageTool).src
        }
        errorType={errorType}
        isError={isError}
        onCloseError={handleOnCloseError}
        product={product || undefined}
      />
      <VfModal
        isOpen={modalConfig.isOpen}
        handleClose={() => {
          setModalConfig({ ...INIT_MODAL_CONFIG });
          if (modalConfig.onCloseAction) {
            modalConfig.onCloseAction();
          }
        }}
      >
        <ModalWrap>
          <div>
            <ModalTitle dangerouslySetInnerHTML={{ __html: pTitle }} />
            {pDescription && (
              <ModalDescription dangerouslySetInnerHTML={{ __html: pDescription }} />
            )}
            {modalConfig.subDesc && (
              <div>
                {modalConfig.subDesc}
                <EditAddress onClick={modalConfig.firstAction}>Modifica indirizzo</EditAddress>
              </div>
            )}
          </div>
          <ButtonDiv>
            {!modalConfig.subDesc && modalConfig.firstActionLabel && modalConfig.firstAction && (
              <ButtonCBU
                onClick={modalConfig.firstAction}
                variant={'primary'}
                name="action_first_coverageToolMap"
              >
                {modalConfig.firstActionLabel}
              </ButtonCBU>
            )}

            {modalConfig.secondActionLabel && modalConfig.secondAction && (
              <ButtonCBU
                variant={'secondary'}
                onClick={modalConfig.secondAction}
                name="action_second_coverageToolMap"
              >
                {modalConfig.secondActionLabel}
              </ButtonCBU>
            )}
          </ButtonDiv>
        </ModalWrap>
      </VfModal>
    </>
  );
};

export default CoverageToolMapCard;

